import { mapCurrencyFromDTO } from '@/modules/common/mappers/currency.mapper';
import { mapRateSourceFromDTO } from '@/modules/common/mappers/rate-source.mapper';
import { RateSourceDTO } from '@/modules/common/types/dto/rate-source.dto';

import { AssignmentRate } from '../types/assignment-rate';
import { AssignmentRateResponse } from '../types/dto/response/planner-assignment-response';

export const mapAssignmentRateFromDTO = (dto: AssignmentRateResponse): AssignmentRate => ({
  rate: dto.rate,
  currency: mapCurrencyFromDTO(dto.currency),
  assignmentRateSource: mapRateSourceFromDTO(dto.assignmentRateSource as RateSourceDTO),
  projectBoundRateSource: dto.projectBoundRateSource
    ? mapRateSourceFromDTO(dto.projectBoundRateSource as RateSourceDTO)
    : null,
});
